<!--
 * @title: 页面名称
 * @Description: 
 * @Version: 2.0
 * @Autor: 研发三部
 * @Date: 2020-12-03 09:37:11
 * @LastEditors: wch
 * @LastEditTime: 2020-12-28 16:01:28
-->
<template>
    <div class="external-resource-view" style="height: 100%;">

        <iframe :src="$route.query.url" id="mobsf" frameborder="0" style="width: 100%;height: 100%;"></iframe>

        <span class="home-button">
            <el-button @click="skipHome" icon="el-icon-s-home" circle></el-button>
        </span>
    </div>
</template>

<script>

import * as api from "@/api/cloud-screen";
import CFG from "@/config/config";





export default {
    components: {

    },
    props: {


    },
    data() {
        return {
            urlprefix: CFG.LOTIP,
        };
    },
    watch: {},
    mounted() {
        console.log(this.$route.query)


    },
    methods: {
        skipHome() {
            this.$router.push("/cloud_screen/" + this.$route.params.systemSid);
        },

    },
};
</script>
  
<style lang="scss" scoped>

.home-button {
    z-index: 10;
    position: absolute;
    left: 1%;
    bottom: 5%;
    right: 0;
    height: 80px;
    line-height: 80px;

    background-position: center;
    background-repeat: no-repeat;
    width: 0;
    /*background-size: "contain"*/
}

.home-button /deep/ .el-button--default:hover {
    background: rgba(255, 255, 255, 0.6) !important;
}

.home-button /deep/ .el-button {
    font-size: 1.8vw;
}

.home-button /deep/ .el-button--default {
    background: rgba(255, 255, 255, 0.8) !important;
    color: #5c5959 !important;
    border: none;

}

.home-button /deep/ .el-button.is-circle {
    padding: 5px;
}
</style>

  